import React, { useState, useContext } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import VTradingContext from "../context/vTrading/VTradingContext";
import ParameterContext from "../context/parameter/parameterContext";
import TradathonContext from "../context/tradathon/TradathonContext";
const VtradingDropdown = ({
  amount,
  price,
  id,
  marketPrice,
  type,
  orderType,
  orderId,
  invested,
  coinId,
}) => {
  const [dropDown, setDropdown] = useState(false);
  const { toggleVtradingAlertModal } = useContext(VTradingContext);
  const {
    toggleTradathonModal,
    setCoinCSTAmount,
    tradathon_setActiveCrypto,
    tradathon_setActivePrice,
    tradathon_setSellType,
    tradathon_activeCrypto,
    tradathon_activePrice,
  } = useContext(TradathonContext);

  return (
    <>
      {type === "openOrder" ? (
        <div
          className="Home__MainTable-td"
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={() => {
            setDropdown(!dropDown);
            tradathon_setActiveCrypto({
              ...tradathon_activeCrypto,
              price: Number(marketPrice),
              symbol: id,
            });
            tradathon_setActivePrice({
              ...tradathon_activePrice,
              price: Number(marketPrice),
              amount: Number(amount),
              orderId: orderId,
              CSTAmount: Number(invested),
            });
          }}
        >
          <BsThreeDotsVertical />
          {dropDown && (
            <div
              className="order__profile__transparent"
              style={{ display: "block" }}
            >
              {/* <div className="order_dropdown__triangle"></div> */}
              <div className="order_dropdown">
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    alignItems: "flexStart",
                  }}
                >
                  <li
                    onClick={() => {
                      tradathon_setSellType(orderType);
                      toggleTradathonModal();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Modify Order
                  </li>
                  <li
                    onClick={() => {
                      tradathon_setSellType(orderType);
                      toggleVtradingAlertModal();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    Cancel Order
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      ) : type === "before" ? (
        <div
          className="Home__MainTable-td"
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={() => {
            setDropdown(!dropDown);
            setCoinCSTAmount({
              CSTAmount: invested,
              coinId,
              singleInv: invested,
            });
          }}
        >
          <BsThreeDotsVertical />
          {dropDown && (
            <div
              className="order__profile__transparent"
              style={{ display: "block" }}
            >
              {/* <div className="order_dropdown__triangle"></div> */}
              <div className="order_dropdown">
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    alignItems: "flexStart",
                  }}
                >
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      tradathon_setSellType("buy");
                      toggleTradathonModal();
                    }}
                  >
                    Modify Coin
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      tradathon_setSellType("buy");
                      toggleVtradingAlertModal();
                    }}
                  >
                    Delete Coin
                  </li>
                </ul>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div
          className="Home__MainTable-td"
          style={{ marginLeft: "10px", cursor: "pointer" }}
          onClick={() => {
            setDropdown(!dropDown);
            tradathon_setActiveCrypto({
              price: Number(marketPrice),
              symbol: id,
            });

            tradathon_setActivePrice({
              ...tradathon_activePrice,
              price: Number(marketPrice),
              amount: Number(amount),
              orderId: orderId,
              CSTAmount: Number(invested),
              coinId: coinId,
              maxAmount: Number(amount),
            });
          }}
        >
          <BsThreeDotsVertical />
          {dropDown && (
            <div
              className="order__profile__transparent"
              style={{ display: "block" }}
            >
              {/* <div className="order_dropdown__triangle"></div> */}
              <div className="order_dropdown">
                <ul
                  style={{
                    listStyleType: "none",
                    paddingLeft: 0,
                    alignItems: "flexStart",
                  }}
                >
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => toggleVtradingAlertModal()}
                  >
                    Sell All
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      tradathon_setSellType("sell");
                      toggleTradathonModal();
                    }}
                  >
                    Sell by Part
                  </li>
                  <li
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      tradathon_setSellType("buy");
                      toggleTradathonModal();
                    }}
                  >
                    Add more {tradathon_activeCrypto.symbol}
                  </li>
                </ul>
              </div>
            </div>
            // <div className="Vtrading__dropdown">
            //   <div className="Vtrading__profile__transparent">
            //     <div className="Vtrading__profile__dropdown__triangle"></div>
            //     <div className="Vtrading__profile__dropdown">
            //       <ul>
            //         <li onClick={() => toggleVtradingAlertModal()}>Sell All</li>
            //         <li
            //           onClick={() => {
            //             tradathon_setSellType("sell");
            //             toggleTradathonModal();
            //           }}
            //         >
            //           Sell by Part
            //         </li>
            //         <li
            //           onClick={() => {
            //             tradathon_setSellType("buy");
            //             toggleTradathonModal();
            //           }}
            //         >
            //           Add more {tradathon_activeCrypto.symbol}
            //         </li>
            //       </ul>
            //     </div>
            //   </div>
            // </div>
          )}
        </div>
      )}
    </>
  );
};

export default VtradingDropdown;
